import { render, staticRenderFns } from "./ButtonResetFilters.vue?vue&type=template&id=6c775c9b&scoped=true"
import script from "./ButtonResetFilters.vue?vue&type=script&lang=js"
export * from "./ButtonResetFilters.vue?vue&type=script&lang=js"
import style0 from "./ButtonResetFilters.vue?vue&type=style&index=0&id=6c775c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c775c9b",
  null
  
)

export default component.exports